// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-horizontal-scrolling-menu--scroll-container {
  display: flex;
  height: -moz-max-content;
  height: max-content;
  overflow-y: hidden;
  position: relative;
  width: 100%;
  gap: 6px;
}

.react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar {
  display: none;
}

.react-horizontal-scrolling-menu--inner-wrapper {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./app/components/ui/horizontal-scroll/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,wBAAmB;EAAnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EAIX,QAAQ;AAHV;;AAMA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".react-horizontal-scrolling-menu--scroll-container {\n  display: flex;\n  height: max-content;\n  overflow-y: hidden;\n  position: relative;\n  width: 100%;\n}\n\n.react-horizontal-scrolling-menu--scroll-container {\n  gap: 6px;\n}\n\n.react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar {\n  display: none;\n}\n\n.react-horizontal-scrolling-menu--inner-wrapper {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
